"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.split");
var _regenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _vueFinder = require("@jledentu/vue-finder");
var _validate = require("@/utils/validate");
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'Test',
  components: {
    Finder: _vueFinder.Finder
  },
  props: {
    useForSearch: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      affiliations: [],
      customAffiliations: {},
      listAllIdsFromLastItem: [],
      items: {},
      pathToListItem: [],
      selectedId: null,
      disabledButton: true
    };
  },
  mounted: function () {
    var _mounted = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
      var _affiliation, createAffiliationTree, element;
      return (0, _regenerator2.default)().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            createAffiliationTree = function _createAffiliationTre(affiliation) {
              return {
                id: affiliation.id,
                label: affiliation.name,
                children: affiliation.affiliations.map(function (affiliationNestedItem) {
                  return createAffiliationTree(affiliationNestedItem);
                })
              };
            };
            _context.n = 1;
            return this.$store.dispatch('company/fetchAffiliation');
          case 1:
            _affiliation = this.$store.getters.affiliations;
            // /データを Finder の形式に変換する
            element = {
              id: 'root',
              children: _affiliation.map(function (item) {
                return createAffiliationTree(item);
              })
            };
            this.customAffiliations = element;
            this.affiliations = this.$store.getters.affiliations;
          case 2:
            return _context.a(2);
        }
      }, _callee, this);
    }));
    function mounted() {
      return _mounted.apply(this, arguments);
    }
    return mounted;
  }(),
  methods: {
    onExpand: function onExpand(_ref) {
      var expanded = _ref.expanded,
        sourceEvent = _ref.sourceEvent;
      var selected = expanded.join().split(',')[expanded.length - 1];
      this.selectedId = selected;
      this.disabledButton = false;
    },
    getRequiredData: function getRequiredData() {
      var valueSelected = this.selectedId;
      var affiliations = this.affiliations;
      var _pathToListItem = [];
      var _listAllIdFromLastItem = [];
      function subReloadAffiliation(_affiliation, accept) {
        // acceptは、父親のIDを取得しないことを意味します
        if (accept && _affiliation.id >= 0) {
          _listAllIdFromLastItem.push(_affiliation.id);
        }
        return _affiliation.affiliations.map(function (ite) {
          return subReloadAffiliation(ite, true);
        });
      }
      function reloadAffiliation(affiliation) {
        // eslint-disable-next-line eqeqeq
        if (affiliation.id == valueSelected) {
          var pathFromDepth = (0, _validate.depthFirstSearch)(affiliations, [affiliation]);
          _pathToListItem = pathFromDepth;
          subReloadAffiliation(affiliation, true);
        }
        return affiliation.affiliations.map(function (item) {
          return reloadAffiliation(item);
        });
      }
      affiliations.map(function (i) {
        return reloadAffiliation(i);
      });
      // eslint-disable-next-line eqeqeq
      if (valueSelected == -1) {
        // （-1）がすべてです
        _listAllIdFromLastItem = [];
        // eslint-disable-next-line eqeqeq
      } else if (valueSelected != -1 && valueSelected < 0) {
        // （全てグループ）の子供たち
        subReloadAffiliation(_pathToListItem[_pathToListItem.length - 2], false);
      }
      this.pathToListItem = _pathToListItem;
      this.listAllIdsFromLastItem = _listAllIdFromLastItem;
    },
    sendData: function () {
      var _sendData = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2() {
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.getRequiredData();
            case 1:
              _context2.n = 2;
              return this.$store.commit('company/pathToListItem', this.pathToListItem);
            case 2:
              if (!this.useForSearch) {
                _context2.n = 3;
                break;
              }
              _context2.n = 3;
              return this.$store.commit('company/getDataSearchAffiliation', this.listAllIdsFromLastItem);
            case 3:
              this.$emit('panretToggleDrawer');
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function sendData() {
        return _sendData.apply(this, arguments);
      }
      return sendData;
    }()
  }
};